var _vars    = require('../../modules/vars')._vars;
var difyApi  = require('../../modules/providers/dify/api');
var parser   = require('../../ui/formatters/key-points-parser');
var renderer = require('./key-points-renderer');
var rating   = require('./key-points-rating');

var AUTO_SUMMARIZE_QUERY = 'summarize this article';

// Tracks artGuids that have already fired an insights API call so we never
// fire a duplicate request for the same article. Set synchronously at the
// moment we commit to the call (before any async work) so a re-entrant call
// is blocked with no in-flight window. Only reset when no API call was
// actually made (e.g. token unavailable), so a real duplicate can't happen.
var initializedGuids = {};

function summarizeArticle() {

    var artGuid = '';

    if (_vars.articleParams) {
        // Use URL parameters if available
        artGuid = _vars.articleParams.guid;
    } else if(Number(PageMetadata.pageSegVars.cmsid) == 2) {
        artGuid = PageMetadata.pageSegVars.asst;
    } else {
        artGuid = PageMetadata.pageSegVars.art.replace(/\D/g, '');
    }

    if (window && window.mscpA2A &&  window.artToArtConfig && window.artToArtConfig.currentArticleId) {
        artGuid = window.artToArtConfig.currentArticleId;
    } 

    // Guard: skip if an insights API call has already been fired for this artGuid.
    if (artGuid && initializedGuids[artGuid]) {
        return;
    }

    // Guard 3: skeleton wrapper must be present in the page HTML
    var wrapper = document.querySelector('#ai-wrapper-key-points, #ai-wrapper-key-points-'+ artGuid);
    var jumpLink = document.querySelector('#jump-to-key-points-'+ artGuid);
    if (!wrapper) {
        return;
    }

    // Commit to the call synchronously — any re-entrant call is now blocked.
    initializedGuids[artGuid] = true;

    var tokenPromise = _vars.token
        ? Promise.resolve()
        : difyApi.generateToken().then(function(tokenJSON) {
            if (tokenJSON && tokenJSON.token) {
                _vars.token = 'Bearer ' + tokenJSON.token;
            }
        });

    tokenPromise.then(function() {
        if (!_vars.token) {
            // Token unavailable — no API call was made, allow a future retry.
            initializedGuids[artGuid] = false;
            wrapper.classList.add('inactive');
            return;
        }

        var abortController = new AbortController();
        var timeout = window.insightAPITimeout || 5000;
        var timeoutId;

        var timeoutPromise = new Promise(function(_, reject) {
            timeoutId = setTimeout(function() {
                abortController.abort();
                reject(new Error('TIMEOUT'));
            }, timeout);
        });

        return Promise.race([
            difyApi.getArticleInsights(AUTO_SUMMARIZE_QUERY, abortController.signal),
            timeoutPromise
        ])
            .then(function (response) {

                // Race settled before the timeout — stop the pending timer.
                clearTimeout(timeoutId);

                if (!response.ok) {
                    // Call was made but failed — keep it flagged so we don't retry.
                    wrapper.classList.add('inactive');
                    jumpLink && jumpLink.classList.add('inactive');
                    return;
                }

                return response.json();
            })
            .then(function (json) {
                if (!json) {
                    // Response arrived but empty — call was made, keep it flagged.
                    wrapper.classList.add('inactive');
                    jumpLink && jumpLink.classList.add('inactive');
                    return;
                }

                var keyPointsRendered = false;
                var followUpsRendered = false;

                // Key points — render immediately on arrival
                if (json.key_points && typeof json.key_points === 'string') {
                    var bullets = parser.parseBullets(json.key_points.trim());
                    keyPointsRendered = renderer.renderKeyPoints(bullets, wrapper);
                }

                // Dive Deeper section — AI follow-up prompts (if any) plus the static Deep Dive
                // pills (see key-points-renderer's renderFollowUps).
                var followUpQuestions = Array.isArray(json.follow_up_questions) ? json.follow_up_questions : [];
                if (keyPointsRendered || followUpQuestions.length) {
                    followUpsRendered = renderer.renderFollowUps(followUpQuestions, wrapper);
                }

                // PROFCORE-34854: thumbs up/down, Condition pages only, after follow-ups.
                if (_vars.isConditionPage && keyPointsRendered) {
                    renderer.renderRating(wrapper);
                    rating.init();
                }

                // Tracking events for received key points and follow-ups
                if (keyPointsRendered && followUpsRendered) {
                    wmdPageLink('ai-search_kpt-and-flwups-rcvd');
                } else if (keyPointsRendered) {
                    wmdPageLink('ai-search_kpt-rcvd');
                } else if (followUpsRendered) {
                    wmdPageLink('ai-search_flwups-rcvd');
                }
            })
            .catch(function(error) {
                clearTimeout(timeoutId);

                if (error.message === 'TIMEOUT' || error.name === 'AbortError') {
                    console.log('Article insights request timed out', error);
                } else {
                    console.log('Error fetching article insights:', error);
                }

                // A request was already fired — keep it flagged so no duplicate goes out.
                wrapper.classList.add('inactive');
                jumpLink && jumpLink.classList.add('inactive');
            });

    }).catch(function() {
        console.log('Error generating token for article insights');
        // Token generation failed — no API call was made, allow a future retry.
        initializedGuids[artGuid] = false;
        wrapper.classList.add('inactive');
        jumpLink && jumpLink.classList.add('inactive');
		return;
    });
}

module.exports = {
    summarizeArticle: summarizeArticle
};
